import { Box, Button, MenuItem, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TimePicker } from "@mui/x-date-pickers";
import authService from "../Auth/AuthService";
import { hourCalculaater } from "../utils/hourCalculaater";
import dayjs from "dayjs";
import { useRef } from "react";


const getShift = (time) => {
    const hour = time.hour();
    if (hour >= 6 && hour < 14) return "MORNING";
    if (hour >= 14 && hour < 22) return "EVENING";
    return "NIGHT";
};

export default function ManualEntry({ record = {}, onSuccess }) {

    const hasFetched = useRef(false);
    const [inTime, setInTime] = useState(null);
    const [outTime, setOutTime] = useState(null);
    const [shift, setShift] = useState("");
    const [totalHours, setTotalHours] = useState("");

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        const parsed = dayjs(
            record.inTime,
            ["HH:mm", "HH:mm:ss", "HH:mm:ss.SSS"],
            true
        );

        if (!parsed.isValid()) {
            console.error("Invalid inTime from backend:", record.inTime);
            return;
        }
        setInTime(parsed);
        setShift(record.shift);

    }, [record]);

    const handleInTimeChange = (time) => {
        setInTime(time);
        if (time) setShift(getShift(time));
    };

    const handleOutTimeChange = (time) => {
        setOutTime(time);
        if (time && inTime) {
            setTotalHours(
                hourCalculaater(
                    inTime.format("HH:mm"),
                    time.format("HH:mm")
                )
            );
        }
    };

    const punchIn = async () => {

        await authService.postAuth(
            authService.pathUrl("POST", "/attendance/manual-entry"), {
            empId: record.empId,
            attendDate: record.attendDate,
            inTime: inTime?.format("HH:mm"),
            outTime: outTime?.format("HH:mm"),
            shift,
            month: inTime?.month(),
        });
        if (onSuccess) onSuccess();
    };

    const punchOut = async () => {
        if (!record?.id) return;
        await authService.putAuth(
            authService.pathUrl("PUT", "/attendance/manual-punch-out"), {
            id: record.id,
            empId: record.empId,
            attendDate: record.attendDate,
            inTime: inTime?.format("HH:mm"),
            outTime: outTime?.format("HH:mm"),
        });
        if (onSuccess) onSuccess();
    };

    return (
        <Box display="flex" gap={2} flexWrap={'wrap'} justifyContent={'space-evenly'}>
            <TextField
                select
                size="small"
                label="Shift"
                value={shift}
                disabled
                sx={{ width: 220 }}
            >
                {["MORNING", "EVENING", "NIGHT"].map((s) => (
                    <MenuItem key={s} value={s}>
                        {s}
                    </MenuItem>
                ))}
            </TextField>

            <TextField
                size="small"
                label="Attend Date"
                value={record.attendDate}
                disabled
                sx={{ width: 220 }}
            />
            <TextField
                // size="small"
                label="Total Hours"
                value={totalHours}
                disabled
                sx={{ width: 220 }}
            />
            {/* <DatePicker
                label="Date"
                value={nowDate}
                onChange={setNowDate}
                slotProps={{ textField: { size: "small", sx: { width: 200 } } }}
            /> */}

            <TimePicker
                size="small"
                sx={{ width: 220 }}
                label="In Time"
                value={inTime}
                onChange={handleInTimeChange}
                disabled={Boolean(record?.inTime)}
            />

            <TimePicker
                size="small"
                sx={{ width: 220 }}
                label="Out Time"
                value={outTime}
                onChange={handleOutTimeChange}
                disabled={!inTime}
            />

            <Button variant="contained" onClick={record?.id ? punchOut : punchIn}
                sx={{ bgcolor: '#1b1914', py: 0.5, borderRadius: 2, width: 220 }}>
                submit
            </Button>
        </Box>

    )
}